// Human-curated catalog of the screens exposed by the explorer.
// Order, labels and grouping matter; the registry JSON only knows file paths.

import * as Screens from "../screens-all.js";

export const SCREEN_GROUPS = [
  {
    id: "materia-hub",
    title: "Hub · Materia desktop",
    variant: "materia",
    width: 1440,
    height: 900,
    items: [{ slug: "hoy", label: "Hoy · default", component: Screens.ScreenMHub }],
  },
  {
    id: "materia-flash",
    title: "Flash · Materia desktop (10)",
    variant: "materia",
    width: 1440,
    height: 900,
    items: [
      { slug: "fl-player",    label: "01 · Player A3 evidencia",          component: Screens.ScreenMFlashPlayer },
      { slug: "fl-micro",     label: "02 · Microaction · tap-select",     component: Screens.ScreenMFlashMicro },
      { slug: "fl-correct",   label: "03 · FeedbackCorrect",              component: Screens.ScreenMFlashCorrect },
      { slug: "fl-incorrect", label: "04 · FeedbackIncorrect",            component: Screens.ScreenMFlashIncorrect },
      { slug: "fl-endcard",   label: "05 · EndCard · concepto/evid/caut", component: Screens.ScreenMFlashEnd },
      { slug: "fl-tf",        label: "06 · V/F · RSI myth",               component: Screens.ScreenMFlashTF },
      { slug: "fl-freeze",    label: "07 · FreezePanel",                  component: Screens.ScreenMFlashFreeze },
      { slug: "fl-reading",   label: "08 · ReadingCard · article",        component: Screens.ScreenMFlashReading },
      { slug: "fl-audio",     label: "09 · AudioOnly · narrado + quiz",   component: Screens.ScreenMFlashAudio },
      { slug: "fl-spaced",    label: "10 · Recap/Spaced · flashcard",     component: Screens.ScreenMFlashSpaced },
    ],
  },
  {
    id: "materia-explica-player",
    title: "Explica · Player Materia (6 actos)",
    variant: "materia",
    width: 1440,
    height: 900,
    items: [
      { slug: "ex-intro",    label: "01 · Intro · pregunta + objetivos",  component: Screens.ScreenMExplicaIntro },
      { slug: "ex-act",      label: "02 · Player / Act A3",               component: Screens.ScreenMExplicaAct },
      { slug: "ex-freeze",   label: "03 · Freeze · context menu",         component: Screens.ScreenMExplicaFreeze },
      { slug: "ex-lab",      label: "04 · Lab · DrawZone takeover",       component: Screens.ScreenMExplicaLab },
      { slug: "ex-transfer", label: "05 · Transfer · UnseenChart",        component: Screens.ScreenMExplicaTransfer },
      { slug: "ex-recap",    label: "06 · Recap · 3 tarjetas + spaced",   component: Screens.ScreenMExplicaRecap },
    ],
  },
  {
    id: "materia-explica-ex",
    title: "Explica · Ejercicios (6 tipos)",
    variant: "materia",
    width: 1440,
    height: 900,
    items: [
      { slug: "ex-mc",       label: "01 · MultipleChoice",                 component: Screens.ScreenMExMC },
      { slug: "ex-tf",       label: "02 · True/False · correct + porqué",  component: Screens.ScreenMExTF },
      { slug: "ex-label",    label: "03 · ChartLabeling · tabla a11y",     component: Screens.ScreenMExChartLabel },
      { slug: "ex-compare",  label: "04 · CompareCharts · diptych",        component: Screens.ScreenMExCompare },
      { slug: "ex-replay",   label: "05 · ReplayDecision · incorrect",     component: Screens.ScreenMExReplay },
      { slug: "ex-explain",  label: "06 · ExplainInWords · rubric",        component: Screens.ScreenMExExplain },
    ],
  },
  {
    id: "materia-overlays-states",
    title: "Explica · Overlays + Estados (5)",
    variant: "materia",
    width: 1440,
    height: 900,
    items: [
      { slug: "ov-tutor",    label: "01 · Tutor · refusal + hint ladder",  component: Screens.ScreenMOverlayTutor },
      { slug: "ov-source",   label: "02 · Source · claim strength",        component: Screens.ScreenMOverlaySource },
      { slug: "ov-glossary", label: "03 · Glossary + BranchMenu",          component: Screens.ScreenMOverlayGlossary },
      { slug: "st-lowbw",    label: "04 · State · LowBandwidth",           component: Screens.ScreenMStateLowBw },
      { slug: "st-nolive",   label: "05 · State · NoLiveCase",             component: Screens.ScreenMStateNoLive },
    ],
  },
  {
    id: "materia-course",
    title: "Course · Materia (5)",
    variant: "materia",
    width: 1440,
    height: 900,
    items: [
      { slug: "co-hub",         label: "01 · Hub Overview",        component: Screens.ScreenMCHub },
      { slug: "co-module",      label: "02 · Module Overview",     component: Screens.ScreenMCModule },
      { slug: "co-mastery",     label: "03 · MasteryCheck",        component: Screens.ScreenMCMastery },
      { slug: "co-diag-intake", label: "04 · Diagnostic Intake",   component: Screens.ScreenMCDiagIntake },
      { slug: "co-diag-result", label: "05 · Diagnostic Result",   component: Screens.ScreenMCDiagResult },
    ],
  },
  {
    id: "materia-course-deeper",
    title: "Course · Deeper (4)",
    variant: "materia",
    width: 1440,
    height: 900,
    items: [
      { slug: "co-lab",       label: "01 · Module Lab",          component: Screens.ScreenMCLab },
      { slug: "co-livecase",  label: "02 · LiveCase slot",       component: Screens.ScreenMCLiveCase },
      { slug: "co-tutorclinic",label: "03 · Tutor Clinic",       component: Screens.ScreenMCTutorClinic },
      { slug: "co-complete",  label: "04 · Course Complete",     component: Screens.ScreenMCComplete },
    ],
  },
  {
    id: "materia-course-project",
    title: "Course · Project (3)",
    variant: "materia",
    width: 1440,
    height: 900,
    items: [
      { slug: "co-pr-brief",     label: "01 · Project Brief",      component: Screens.ScreenMCProjBrief },
      { slug: "co-pr-workspace", label: "02 · Project Workspace",  component: Screens.ScreenMCProjWorkspace },
      { slug: "co-pr-review",    label: "03 · Project Review",     component: Screens.ScreenMCProjReview },
    ],
  },
  {
    id: "cristal-mobile",
    title: "Mobile Cristal v1 (15)",
    variant: "cristal",
    width: 390,
    height: 844,
    items: [
      { slug: "m-hub",            label: "Hub · Hoy",                  component: Screens.ScreenHubHoy },
      { slug: "m-fl-player",      label: "Flash · Player",             component: Screens.ScreenFlashPlayer },
      { slug: "m-fl-micro",       label: "Flash · Microaction",        component: Screens.ScreenFlashMicroaction },
      { slug: "m-fl-correct",     label: "Flash · FeedbackCorrect",    component: Screens.ScreenFlashCorrect },
      { slug: "m-fl-incorrect",   label: "Flash · FeedbackIncorrect",  component: Screens.ScreenFlashIncorrect },
      { slug: "m-fl-endcard",     label: "Flash · EndCard",            component: Screens.ScreenFlashEndCard },
      { slug: "m-ex-intro",       label: "Explica · Intro",            component: Screens.ScreenExplicaIntro },
      { slug: "m-ex-act",         label: "Explica · Act",              component: Screens.ScreenExplicaAct },
      { slug: "m-ex-freeze",      label: "Explica · Freeze",           component: Screens.ScreenExplicaFreeze },
      { slug: "m-ex-lab",         label: "Explica · Lab",              component: Screens.ScreenExplicaLab },
      { slug: "m-ex-transfer",    label: "Explica · Transfer",         component: Screens.ScreenExplicaTransfer },
      { slug: "m-ex-recap",       label: "Explica · Recap",            component: Screens.ScreenExplicaRecap },
      { slug: "m-co-hub",         label: "Course · Hub",               component: Screens.ScreenCourseHub },
      { slug: "m-co-module",      label: "Course · Module",            component: Screens.ScreenCourseModule },
      { slug: "m-co-mastery",     label: "Course · Mastery",           component: Screens.ScreenCourseMastery },
    ],
  },
];

export function flattenScreens() {
  const out = [];
  for (const g of SCREEN_GROUPS) {
    for (const it of g.items) {
      if (it.component) {
        out.push({
          ...it,
          groupId: g.id,
          groupTitle: g.title,
          variant: g.variant,
          width: g.width,
          height: g.height,
        });
      }
    }
  }
  return out;
}

export function findScreen(slug) {
  return flattenScreens().find((s) => s.slug === slug);
}

export function countByVariant() {
  return flattenScreens().reduce(
    (acc, s) => {
      acc[s.variant] = (acc[s.variant] || 0) + 1;
      acc.total++;
      return acc;
    },
    { total: 0 },
  );
}
